import { SortBy } from '../../../redesign/clients/design_assets/AssetSortMenuItems';
import { DesignAsset } from '../../../redesign/clients/design_assets/types';

export const DEFAULT_DESIGN_ASSET_SORT: SortBy = {
  key: 'name',
  ascending: true
};

const compareById = (a: DesignAsset, b: DesignAsset): number => a.id - b.id;

const compareByName = (a: DesignAsset, b: DesignAsset): number => {
  const nameComparison = a.name.localeCompare(b.name);

  return nameComparison || compareById(a, b);
};

const compareByDate = (
  key: 'createdAt' | 'updatedAt',
  a: DesignAsset,
  b: DesignAsset
): number => {
  const aDate = new Date(a[key]).getTime();
  const bDate = new Date(b[key]).getTime();

  return aDate === bDate ? compareById(a, b) : aDate - bDate;
};

export const searchAndSortDesignAssets = (
  assets: DesignAsset[],
  search: string,
  sortBy: SortBy | null = DEFAULT_DESIGN_ASSET_SORT
): DesignAsset[] => {
  let assetsClone = assets.slice();

  if (search) {
    assetsClone = assetsClone.filter(({ name }) =>
      name.toLowerCase().includes(search.toLowerCase())
    );
  }

  const activeSort = sortBy || DEFAULT_DESIGN_ASSET_SORT;

  if (activeSort.key === 'createdAt' || activeSort.key === 'updatedAt') {
    assetsClone.sort((a, b) => compareByDate(activeSort.key, a, b));
  } else if (activeSort.key === 'name') {
    assetsClone.sort(compareByName);
  } else if (activeSort.key === 'fileType') {
    assetsClone.sort((a, b) => Number(b.isFigma) - Number(a.isFigma));
  } else {
    assetsClone.sort(
      (a, b) => (a[activeSort.key] || 0) - (b[activeSort.key] || 0)
    );
  }

  return activeSort.ascending ? assetsClone : assetsClone.reverse();
};
